
import { twicifyAirtable, twicPreview } from '~/helpers/twicpics'

export default {
  name: 'ProductExerpt',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    twicPreview() {
      return twicPreview(
        this.product.imgUrl,
        'airtable',
        'https://dl.airtable.com/.attachments/'
      )
    },
    twicSrc() {
      return twicifyAirtable(this.product.imgUrl)
    }
  }
}
